import React from "react";
import PublicHeader from "./PublicHeader";

export default function AboutZab() {

  return (
    <>
      <PublicHeader hideWhenAuthenticated />

      {/* Page content — always render */}
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow p-6">
        <img
          src="/aitranslation.png"
          alt="About Zab AI Translation"
          className="w-[120px] h-auto rounded-md mb-4"
        />

        <p className="text-base text-gray-700 mb-4">
          Every organization is unique, and so are your translation needs. Our mission is to help you{" "}
          <b>build tailored language solutions</b> that fit seamlessly into your workflow, making your
          job easier instead of forcing you into a rigid, one-size-fits-all process.
        </p>

        <p className="text-base text-gray-700 mb-4">
          We partner with businesses worldwide to <b>elevate their global brands</b>. By collaborating closely
          with you, we ensure that your messaging resonates across markets while enhancing your customers&#39;
          experience. From <b>translation and localization</b> to <b>content management, branding, and global
          strategy</b>, we deliver end-to-end solutions that help your brand succeed wherever your audience may be.
        </p>

        <p className="text-base text-gray-700 mb-4">
          We believe that smart technology transforms translation. By integrating the latest innovations, including
          AI-powered translation, we improve quality, streamline workflows, and reduce costs without compromising
          your brand&#39;s voice.
        </p>

        <p className="text-base text-gray-700 mb-4">
          Ready to explore a <b>custom translation process</b> designed around your goals?
        </p>

        <p className="text-base text-gray-700 font-semibold">
          <a
            href="https://zabtranslation.com/request-a-free-quote-detailed.html"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:opacity-90"
            style={{ color: "#00a7e1" }}
          >
            Schedule a consultation
          </a>{" "}
          with our team today, and let’s build your global success story together.
        </p>
      </div>
    </>
  );
}
